import { render, staticRenderFns } from "./PaymentMethodFormLabel.vue?vue&type=template&id=7261dc68&scoped=true&"
import script from "./PaymentMethodFormLabel.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodFormLabel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodFormLabel.vue?vue&type=style&index=0&id=7261dc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261dc68",
  null
  
)

export default component.exports